import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Paper } from '@mui/material';
import PromoFinancingConfiguration from './PromoFinancingConfig';
import AppearanceConfiguration from './AppearanceConfig';
import GrillsConfiguration from './GrillsConfig';
import GlassConfiguration from './GlassConfig';
import FinishConfiguration from './FinishConfig';
import InstallationConfiguration from './InstallationConfig';
import PricingConfiguration from './PricingConfig';
import './tabs.css';

const PFAPsetup = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'promoFinancing');

  return (
    <div className="content-container">

      <Paper sx={{ p: 1, pb: 1.2, marginBottom: 2 }}>
        <h3>Configuration</h3>
      </Paper>

      {/* Tab Navigation */}
      <div className="tabs">
        <button
          className={activeTab === 'promoFinancing' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('promoFinancing')}
        >
          Promo/Financing
        </button>
        <button
          className={activeTab === 'appearance' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('appearance')}
        >
          Appearance
        </button>
        <button
          className={activeTab === 'pricing' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('pricing')}
        >
          Pricing
        </button>
        <button
          className={activeTab === 'grills' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('grills')}
        >
          Grills
        </button>
        <button
          className={activeTab === 'glass' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('glass')}
        >
          Glass
        </button>
        <button
          className={activeTab === 'finish' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('finish')}
        >
          Finish
        </button>
        <button
          className={activeTab === 'installation' ? 'tab active' : 'tab'}
          onClick={() => setActiveTab('installation')}
        >
          Installation
        </button>

      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'promoFinancing' && <PromoFinancingConfiguration />}
        {activeTab === 'appearance' && <AppearanceConfiguration />}
        {activeTab === 'pricing' && (
          <PricingConfiguration
            initialTab={searchParams.get('pricingTab') || ''}
            highlightRule={searchParams.get('rule') || ''}
          />
        )}
        {activeTab === 'grills' && <GrillsConfiguration />}
        {activeTab === 'glass' && <GlassConfiguration />}
        {activeTab === 'finish' && <FinishConfiguration />}
        {activeTab === 'installation' && <InstallationConfiguration />}
      </div>
    </div>
  );
};

export default PFAPsetup;
